// test2798
(2798 && 0);
